const separator = '...'

export default function truncate({
  fullString,
  frontChars = 9,
  backChars = 3,
}: {
  fullString?: string | undefined
  frontChars?: number
  backChars?: number
}) {
  if (!fullString) return
  if (fullString.length <= separator.length + frontChars + backChars)
    return fullString

  return (
    fullString.substring(0, frontChars) +
    separator +
    fullString.substring(fullString.length - backChars)
  )
}
